"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTimeout = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useTimeout = (callback, delay) => {
  const savedCallback = _react.default.useRef(callback);

  // Remember the latest callback if it changes.
  _react.default.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout
  _react.default.useEffect(() => {
    // Don't schedule if no delay is specified
    if (delay === null) return;
    const id = setTimeout(() => savedCallback.current(), delay);
    return () => clearTimeout(id);
  }, [delay]);
};
exports.useTimeout = useTimeout;